<div class="card text-left h-100">
  <div class="card-header bg-light">
    <h4 class="card-title mb-0">{{ titulo }} Solicitação Técnica</h4>
    <div class="text-right" *ngIf="model?.status?.codigo === 5 && !visualizar">
      <button type="button" class="btn btn-warning btn-sm " (click)="avaliar()"> Avaliar Prorrogação</button>
    </div>
  </div>
  <div class="card-body wrapper m-0">
    <form class="needs-validation" novalidate id="myForm" #f="ngForm" [formGroup]="incluirSolicitacao">
      <div class="row mt-2">
        <div [ngClass]="model.numero ? 'col-sm-3' : 'col-sm-4'">
          <label for="validationCustom01" class="form-label">Associado à:</label>
          <input type="text" maxlength="100" name="associado" class="form-control form-control-sm" id="associadoAId"
            disabled placeholder="-" [(ngModel)]="model.documentoAssociado" [ngModelOptions]="{standalone: true}" />
        </div>
        <div class="col-sm-3" *ngIf="model.numero">
          <label for="validationCustom02" class="form-label">Nº Solicitação:</label>
          <input type="text" name="nSolicitacaoTecnica" class="form-control form-control-sm" id="nSolicitacao" disabled
            placeholder="-" [ngModel]="model?.numero" maxlength="15" [ngModelOptions]="{standalone: true}" />
        </div>
        <div [ngClass]="model.numero ? 'col-sm-3' : 'col-sm-4'">
          <label for="validationCustom01" class="form-label">Prazo para Resposta: </label>
          <input type="text" class="form-control form-control-sm" id="prazoResposta" formControlName="prazoResposta"
            placeholder="DD/MM/AAAA" bsDatepicker [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY' }"
            [ngClass]="{ 'is-invalid': submitted && incluirSolicitacao.controls['prazoResposta'].invalid }" />
          <div *ngIf="submitted &&  incluirSolicitacao.controls['prazoResposta'].invalid" class="invalid-feedback">
            <div *ngIf="incluirSolicitacao.controls['prazoResposta'].errors.required">Campo obrigatório</div>
            <div *ngIf="incluirSolicitacao.controls['prazoResposta'].errors.dataMenorHoje">Data não pode ser anterior a
              hoje</div>
            <div *ngIf="incluirSolicitacao.controls['prazoResposta'].errors.dataMaiorLimite">Data excede o limite
              permitido</div>
          </div>
        </div>
        <div [ngClass]="model.numero ? 'col-sm-3' : 'col-sm-4'">
          <label for="validationCustom01" class="form-label">Tipo de Solicitação: </label>
          <ng-select id="tipo" formControlName="tipo"
            [ngClass]="{'is-invalid': submitted && incluirSolicitacao.controls['tipo'].invalid }">
            <ng-option *ngFor="let tipo of tiposSolicitacaoTecnica" [value]="tipo.value">
              {{ tipo.text }}
            </ng-option>
          </ng-select>
          <div *ngIf="submitted &&  incluirSolicitacao.controls['tipo'].invalid" class="invalid-feedback">
            <div *ngIf="incluirSolicitacao.controls['tipo'].errors.required">Campo obrigatório</div>
          </div>
        </div>
      </div>
      <div class="row mt-2" *ngIf="incluirSolicitacao.get('tipo')?.value === 1">
        <div class="col-sm-12">
          <!-- Label acima do agrupamento -->
          <label class="form-label fw-bold mb-1">Destinatário:</label>

          <!-- Card do agrupamento -->
          <div class="card card-outline mt-0">
            <div class="card-body p-2">
              <div class="row g-2">
                <div class="form-group col-md-6 mb-1">
                  <label class="form-label">Unidade Gestora:</label>
                  <ng-select id="internaUnidadeGestoraId" formControlName="internaUnidadeGestoraId"
                    (change)="obterResponsaveis(incluirSolicitacao.get('internaUnidadeGestoraId')?.value)"
                    [ngClass]="{'is-invalid': submitted && incluirSolicitacao.controls['internaUnidadeGestoraId'].invalid }">
                    <ng-option *ngFor="let item of unidadesGetoras" [value]="item.value">
                      {{ item.text }}
                    </ng-option>
                  </ng-select>
                </div>

                <div class="form-group col-md-6 mb-1">
                  <label class="form-label">Responsável:</label>
                  <ng-select id="internaResponsavelId" formControlName="internaResponsavelId"
                    [ngClass]="{'is-invalid': submitted && incluirSolicitacao.controls['internaResponsavelId'].invalid }">
                    <ng-option *ngFor="let item of responsaveis" [value]="item.value">
                      {{ item.text }}
                    </ng-option>
                  </ng-select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2" *ngIf="incluirSolicitacao.get('tipo')?.value === 2">
        <div class="col-sm-12">
          <!-- Label acima do agrupamento -->
          <label class="form-label fw-bold mb-1">Destinatário:</label>

          <!-- Card do agrupamento -->
          <div class="card card-outline mt-0">
            <div class="card-body p-2">
              <div class="row g-2">

                <div class="form-group col-md-6 mb-1">
                  <label class="form-label">Nome: </label>
                  <input type="text" name="externaDestinatarioNome" formControlName="externaDestinatarioNome"
                    class="form-control form-control-sm" id="externaDestinatarioNome" maxlength="400" />
                  <div *ngIf="submitted &&  incluirSolicitacao.controls['externaDestinatarioNome'].invalid"
                    class="text-danger text-xs mt-1">
                    <div>Campo obrigatório</div>
                  </div>
                </div>

                <div class="form-group col-md-6 mb-1">
                  <label class="form-label">Responsável: </label>
                  <input type="text" name="externaDestinatarioResponsavel"
                    formControlName="externaDestinatarioResponsavel" class="form-control form-control-sm"
                    id="externaDestinatarioResponsavel" maxlength="400" />
                  <div *ngIf="submitted &&  incluirSolicitacao.controls['externaDestinatarioResponsavel'].invalid"
                    class="text-danger text-xs mt-1">
                    <div>Campo obrigatório</div>
                  </div>
                </div>

                <div class="form-group col-md-3 mb-1">
                  <label class="form-label">CPF/CNPJ: </label>
                  <input type="text" name="externaDestinatarioCPFCNPJ" formControlName="externaDestinatarioCPFCNPJ"
                    class="form-control form-control-sm" id="externaDestinatarioCPFCNPJ" (input)="onCpfCnpjInput()" />
                  <div
                    *ngIf="submitted &&  incluirSolicitacao.controls['externaDestinatarioCPFCNPJ'].hasError('cpfCnpjInvalido')"
                    class="text-danger text-xs mt-1">
                    <div>CPF ou CNPJ Inválido</div>
                  </div>
                </div>

                <div class="form-group col-md-3 mb-1">
                  <label class="form-label">Telefone: </label>
                  <input type="text" name="externaDestinatarioFone" formControlName="externaDestinatarioFone"
                    class="form-control form-control-sm" id="externaDestinatarioFone" [value]="telefoneFormatado"
                    (input)="onTelefoneInput($event)" />
                </div>

                <div class="form-group col-md-6 mb-1">
                  <label class="form-label">E-mail: </label>
                  <input type="email" name="externaDestinatarioEmail" formControlName="externaDestinatarioEmail"
                    class="form-control form-control-sm" id="externaDestinatarioEmail" />
                  <div
                    *ngIf="submitted &&  incluirSolicitacao.controls['externaDestinatarioEmail']?.hasError('required')"
                    class="text-danger text-xs mt-1">
                    <div>Campo obrigatório</div>
                  </div>
                  <div *ngIf="submitted &&  incluirSolicitacao.controls['externaDestinatarioEmail']?.hasError('email')"
                    class="text-danger text-xs mt-1">
                    <div>E-mail inválido</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-sm-12">
          <label for="validationCustom05" class="form-label">Assunto: </label>
          <input type="text" name="assunto" formControlName="assunto" class="form-control form-control-sm" id="assunto"
            maxlength="30" />
          <div *ngIf="submitted &&  incluirSolicitacao.controls['assunto'].invalid" class="text-danger text-xs mt-1">
            <div>Campo obrigatório</div>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-sm-12">
          <label for="validationCustom05" class="form-label">Descrição: </label>
          <div [ngClass]="{ 'border border-danger': submitted && incluirSolicitacao.controls['descricao'].invalid }">
            <angular-editor *ngIf="!visualizar; else descricaoVisualizar" #maxLengthEditor formControlName="descricao"
              [config]="editorConfig" (ngModelChange)="onEditorChange($event)">
            </angular-editor>
            <ng-template #descricaoVisualizar>
              <div class="form-control" [innerHTML]="incluirSolicitacao.controls['descricao'].value"
                style="min-height: 150px; max-height: 300px; overflow-y: auto;">
              </div>
            </ng-template>
          </div>
          <div *ngIf="submitted &&  incluirSolicitacao.controls['descricao'].invalid" class="text-danger text-xs mt-1">
            <div>Campo obrigatório</div>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-sm-12">
          <label for="validationCustom06" class="form-label">Itens</label>
          <div class="mat-elevation-z1">
            <table mat-table [dataSource]="dataSourceItems" matSortDisableClear matSort matSortDirection="asc">
              <tr mat-header-row *matHeaderRowDef="['numero', 'tituloItem', 'status', 'statusAvaliacao', 'actions']"
                class="bg-light">
              </tr>

              <ng-container matColumnDef="numero">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Nº
                </th>
                <td mat-cell *matCellDef="let element">
                  <span *ngIf="!element?.numero">-</span>
                  <span *ngIf="element?.numero">{{ element.numero }}</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="tituloItem">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Titulo do item
                </th>
                <td mat-cell *matCellDef="let element">
                  {{ element.titulo }}
                </td>
              </ng-container>

              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Status
                </th>
                <td mat-cell *matCellDef="let element">
                  <span *ngIf="!element?.statusCalculado">-</span>
                  <span *ngIf="element?.statusCalculado?.codigo === 1"
                    class="badge bg-success text-xs">{{element?.statusCalculado?.descricao}}</span>
                  <span *ngIf="element?.statusCalculado?.codigo === 2"
                    class="badge bg-secondary text-xs">{{element?.statusCalculado?.descricao}}</span>
                  <span *ngIf="element?.statusCalculado?.codigo === 3"
                    class="badge bg-danger text-xs">{{element?.statusCalculado?.descricao}}</span>
                  <span *ngIf="element?.statusCalculado?.codigo === 4"
                    class="badge bg-info text-xs">{{element?.statusCalculado?.descricao}}</span>
                  <span *ngIf="element?.statusCalculado?.codigo === 5"
                    class="badge bg-warning text-xs">{{element?.statusCalculado?.descricao}}</span>
                  <span *ngIf="element?.statusCalculado?.codigo === 6"
                    class="badge bg-primary text-xs">{{element?.statusCalculado?.descricao}}</span>
                  <span *ngIf="element?.statusCalculado?.codigo === 7"
                    class="badge bg-info text-xs">{{element?.statusCalculado?.descricao}}</span>

                  <i *ngIf="element?.statusCalculado?.codigo === 3" class="fas fa-info-circle"
                    [matTooltip]="formatarTooltipCanc(element)" matTooltipClass="tooltip-avaliacao"
                    matTooltipPosition="above" style="cursor: pointer; margin-left: 0.5rem;">
                  </i>

                </td>
              </ng-container>

              <ng-container matColumnDef="statusAvaliacao">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Avaliação
                </th>
                <td mat-cell *matCellDef="let element">
                  <i *ngIf="isStatusAvaliacaoVazio(element?.statusAvaliacao)" class="fas fa-minus text-muted"></i>
                  <span *ngIf="element?.statusAvaliacao.codigo === 1"
                    class="badge bg-info text-xs">{{element?.statusAvaliacao?.descricao}}</span>
                  <span *ngIf="element?.statusAvaliacao?.codigo === 2"
                    class="badge bg-warning text-xs">{{element?.statusAvaliacao?.descricao}}</span>
                  <span *ngIf="element?.statusAvaliacao?.codigo === 3"
                    class="badge bg-danger text-xs">{{element?.statusAvaliacao?.descricao}}</span>

                  <i *ngIf="element?.comentarioAvaliacao" class="fas fa-info-circle"
                    [matTooltip]="formatarTooltipAvaliacao(element)" matTooltipClass="tooltip-avaliacao"
                    matTooltipPosition="above" style="cursor: pointer; margin-left: 0.5rem;">
                  </i>

                </td>
              </ng-container>

              <ng-container cdkColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef style="max-width: 90px;">
                  <button type="button" class="btn btn-success btn-xs w-100"
                    (click)="modalIncluiritem('Incluir', false)" *ngIf="!visualizar">
                    Adicionar
                  </button>
                </th>
                <td mat-cell *matCellDef="let element; let i = index" class="block">
                  <div class="d-flex w-100 justify-content-center align-items-center">
                    <button type="button" class="btn btn-warning btn-xs text-left ml-1"
                      [disabled]="element?.status.codigo === 3" *ngIf="acaoCancelarItem"
                      (click)="cancelarItem(element.id)">
                      <i class="fas fa-ban"></i>
                    </button>
                    <button type="button" class="btn btn-primary btn-xs text-left ml-1" *ngIf="!visualizar"
                      (click)="modalIncluiritem('Editar', false, element)">
                      <i class="fas fa-pen"></i>
                    </button>
                    <button type="button" class="btn btn-info btn-xs text-left ml-1"
                      (click)="modalIncluiritem('Visualizar', true, element)">
                      <i class="far fas fa-eye"></i>
                    </button>
                    <button type="button" class="btn btn-danger btn-xs text-left ml-1" *ngIf="!visualizar"
                      (click)="excluirItem(element.id)"
                      [disabled]="model?.status?.codigo !== 1 && model?.status?.codigo !== 2">
                      <i class="far fa-trash-alt"></i>
                    </button>
                  </div>
                </td>
              </ng-container>

              <tr mat-row
                *matRowDef="let row; columns: ['numero', 'tituloItem', 'status', 'statusAvaliacao', 'actions']"></tr>
            </table>
            <h5 class="table-no-data" [hidden]="dataSourceItems?.data?.length > 0">
              Nenhum registro encontrado
            </h5>
            <mat-paginator [pageSizeOptions]="[5, 10, 15]" showFirstLastButtons>
            </mat-paginator>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="card-footer">
    <div class="d-flex w-100 justify-content-between align-items-center">

      <div class="list2">
        <button *ngIf="!visualizar && model?.status?.codigo === 2" type="button" class="btn btn-success btn-sm mr-1"
          [disabled]="model?.status?.codigo !==2 || dataSourceItems?.data?.length === 0 || !habilitaFinalizarEnviar"
          (click)="enviar()">
          <i class="fas fa-paper-plane"></i> Enviar
        </button>
        <button *ngIf="!visualizar && model?.status?.codigo === 1" type="button" class="btn btn-warning btn-sm mr-1"
          (click)="finalizar()"
          [disabled]="!model?.id || dataSourceItems?.data?.length === 0 || !habilitaFinalizarEnviar">
          <i class="fas fa-check"></i> Finalizar
        </button>
        <button *ngIf="!visualizar" type="button" form="myForm" class="btn btn-primary btn-sm mr-1 " (click)="salvar()">
          <i class="far fa-save"></i> Salvar
        </button>
        <button type="button" class="btn btn-default btn-sm" (click)="cancelar()">
          <i class="fas fa-times"></i> Fechar
        </button>
      </div>
    </div>
  </div>
</div>
